function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.079 6.763L5 15.843V19h3.158l9.079-9.079-3.158-3.158zm5.69-.49l-2.042-2.041a.789.789 0 00-1.116 0l-1.348 1.347 3.158 3.158 1.348-1.348a.789.789 0 000-1.116z",
  fill: "current"
});

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEdit;